module.exports = __webpack_public_path__ + "img/roadmap.198ab94d.png";